var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 78.4375C61.2284 78.4375 78.4375 61.2284 78.4375 40C78.4375 18.7716 61.2284 1.5625 40 1.5625C18.7716 1.5625 1.5625 18.7716 1.5625 40C1.5625 61.2284 18.7716 78.4375 40 78.4375Z",
    fill: "#38A3A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 71.25C54.9493 71.25 67.0682 64.2544 67.0682 55.625C67.0682 46.9956 54.9493 40 39.9999 40C25.0505 40 12.9316 46.9956 12.9316 55.625C12.9316 64.2544 25.0505 71.25 39.9999 71.25Z",
    fill: "#EDEFF1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40C48.6294 40 55.625 33.0044 55.625 24.375C55.625 15.7456 48.6294 8.75 40 8.75C31.3706 8.75 24.375 15.7456 24.375 24.375C24.375 33.0044 31.3706 40 40 40Z",
    fill: "#EDEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0002 58.75L52.6118 42.6502C48.7545 40.9466 44.488 40 40.0002 40C35.5124 40 31.246 40.9466 27.3887 42.6502L40.0002 58.75Z",
    fill: "#D3D3D3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg);
export default __webpack_public_path__ + "static/media/profile-img.6a96a194b3d4d6cd71c350871d340ab5.svg";
export { ForwardRef as ReactComponent };